<template>
    <div class="field field--checkbox">
        <input
            :id="id"
            type="checkbox"
            name="checkbox"
            v-model="inputVal"
            :required="required"
        >
        <label :for="id"><span>{{ label }}</span></label>
    </div>
</template>

<script>
    export default {
        name: 'CoreCheckbox',
        props: {
            id: {
                type: String,
                default() { return `radio-input-${this._uid}`}
            },
            label: {
                type: String,
                default: ''
            },
            value: [String, Number, Boolean, Array],
            required: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            inputVal: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
input[type=checkbox] {
    display: none;
}

.field--checkbox {
    input + label {
        display: inline-flex;
        align-items: center;

        cursor: pointer;

        line-height: 1rem;
    }

    input + label {
        &::before {
            width: 20px;
            height: 20px;
            margin-right: 1rem;

            content: '';

            border: 1px solid var(--border-grey-50);
            border-radius: 4px;
        }
    }

    input:checked + label {
        border-width: 1px;
        border-color: var(--tertiary);

        &::before {
            border-color: var(--primary);
            background-color: var(--primary);
        }
    }
}
</style>
